import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";

const LOGO = "https://customer-assets.emergentagent.com/job_184a0a73-7ed5-43f8-9a23-0cd69b83d3bb/artifacts/rcargp5m_no%20bkg.png";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/rooms", label: "Rooms" },
  { to: "/about", label: "About" },
  { to: "/studio", label: "Studio" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Apply" },
];

// One top nav for every public page. Active link is worked out from the URL.
const PublicNav = () => {
  const { pathname } = useLocation();
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#FBF7F1]/95 backdrop-blur-lg border-b border-stone-100" data-testid="public-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
            <img src={LOGO} alt="Savi" className="h-8 w-auto" />
            <span className="text-lg tracking-wider text-[#C89B7B]">
              <span className="font-display">SAVI</span> <span className="font-serif">Coliving</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {LINKS.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className={pathname === to ? "text-[#C85A38] text-sm font-medium" : "text-[#2E2A26]/60 hover:text-[#2E2A26] text-sm font-medium"}
                data-testid={`nav-${label.toLowerCase()}`}
              >
                {label}
              </Link>
            ))}
          </div>

          <Link to="/login" data-testid="nav-guest-login">
            <Button className="bg-[#C85A38] hover:bg-[#D06A4F] text-white rounded-full px-4 sm:px-6 text-sm">Guest Login</Button>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default PublicNav;
